import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { getColumnTypePalette } from "./assetTypeColumnTheme.js";

export function AssetTypeColumnChips({ columns }) {
  const { c, dark } = useThemeSlice();

  if (!columns?.length) {
    return <span style={{ fontSize: 12, color: c.sub, fontStyle: "italic" }}>No columns defined</span>;
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }}>
      {columns.map((col) => {
        const palette = getColumnTypePalette(col.type, dark);
        return (
          <span
            key={`${col.key}-${col.type}`}
            title={`${col.key} (${col.type})`}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 8px 4px 10px",
              borderRadius: 999,
              border: `1px solid ${palette.border}`,
              background: palette.bg,
              maxWidth: "100%",
            }}
          >
            <span style={{ fontSize: 11.5, fontWeight: 700, color: c.text, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>
              {col.key}
            </span>
            <span
              style={{
                fontSize: 9.5,
                fontWeight: 800,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                color: palette.text,
                padding: "2px 6px",
                borderRadius: 999,
                background: dark ? "rgba(0,0,0,.15)" : "rgba(255,255,255,.65)",
              }}
            >
              {col.type}
            </span>
          </span>
        );
      })}
    </div>
  );
}
